import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ContentStyled = styled(Box).attrs({
  flexGrow: { sm: '1' },
})`
  ${({ theme }) => css`
    height: calc(100% -${theme.componentStyles.pageHeaderHeight});
  `}
`;
